<!--https://local.boxed.bryter-custom.io/legal-intake-tool-v4/calendar/calendar/?env=4NkpRB7lT4mdt_TsSRogQg&a=2&vue-->

<template>
    <CalendarComponent 
        v-if="templateData"
        :templateData="templateData"
        />
</template>

<script>

import CalendarComponent from '@vueapp/components/CalendarComponent.vue'

export default {
    name: 'CalendarView',
    components: {
        CalendarComponent
    },
    data() {
        return {
            templateData: null,
        }
    },
    props: {
        postSlug: String,
        postId: String,
        isViewWrapper: String
    },
    mounted() {
        const params = new URLSearchParams(window.location.search),
            eParams = {}

        params.forEach((value, name) => {
            if ( ! name.match(/env|debug/) && value.match(/^([a-z0-9\_\-\+\ ]+)$/) ) {
                eParams[name] = value
            }
        })
        const paramsString = ( new URLSearchParams(eParams) ) .toString()

        fetch( BRYTER.homeUrl + '/calendar/' + this.postSlug + '/?env=' + BRYTER.envId + '&json&t=' + Date.now() + '&' + paramsString)
            .then(response => response.json())
            .then(data => {
                // this.calendarOptions.events = JSON.parse(data.template_data.calendar_json) ?? [];
                this.templateData = data.template_data ?? null


                if(this.isViewWrapper === 'true') {
                    this.templateData.vw = true
                }
            })
            .catch(error => {
                console.error('Error fetching calendar data:', error);
            });

    }
}


</script>